import React, { useState } from 'react';
import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';

import Section from '../global/section';
import Top from '../top';
import Button from '../global/button';
import ErrorMessage from '../global/error-message';

import mailgunSubmitForm from '../../util/mailgunSubmitForm';

const FormStyle = styled.div`
	text-align: center;

	h2 {
		margin-bottom: 3rem;
	}

	.form-container form {
		display: flex;
		flex-wrap: wrap;
		input,
		textarea {
			margin-bottom: 0.5rem;
			background-color: ${(p) => p.theme.color.light};
			border: 1px solid ${(p) => p.theme.color.lightGrey};
			padding: 0.5rem 1rem;
			&::placeholder {
				color: ${(p) => p.theme.color.grey};
			}
		}

		.recaptcha-container {
			width: 100%;
		}

		#name,
		#phone,
		#email {
			width: calc(27% - 0.5rem);
			margin-right: 0.5rem;
		}
		#age {
			width: 19%;
		}
		#message {
			width: 100%;
			resize: none;
			height: 8rem;
		}
		label {
			margin: 0.5rem 0;
		}

		.bottom-field {
			width: 50%;
			text-align: left;
			label {
				display: block;
			}
			select {
				width: calc(100% - 1rem);
				margin-right: 0.5rem;
				background-color: ${(p) => p.theme.color.light};
				background-image: url(/img/chevron-down.svg);
				background-repeat: no-repeat;
				background-position: right 0.75rem top 50%;
				background-size: 0.7rem auto;
				border: 1px solid ${(p) => p.theme.color.lightGrey};
				font-family: ${(p) => p.theme.fonts.body};
				font-size: 1rem;
				font-weight: 400;
				appearance: none;
				border-radius: 0;
				padding: 0.5rem 1rem;
				color: ${(p) => p.theme.color.grey};
				&.defaultValue {
					color: ${(p) => p.theme.color.dark};
				}
			}
			input {
				width: 100%;
			}
		}

		.file-field {
			width: 30%;
			text-align: left;
			&.letter {
				margin-right: 40%;
			}

			label {
				display: block;
			}
			input {
				margin-bottom: 0.5rem;
				width: 100%;
				background-color: transparent;
				border: none;
				padding: 0.5rem 1rem;
				appearance: none;
			}
		}

		button {
			margin: 2rem auto 0;
			display: inline-block;
		}
		@media all and (max-width: 1000px) {
			#name {
				width: calc(50% - 0.5rem);
			}
			#phone {
				width: 50%;
				margin-right: 0;
			}
			#email {
				width: calc(75% - 0.5rem);
			}
			#age {
				width: 25%;
			}
		}
		@media all and (max-width: 868px) {
			.file-field {
				width: 50%;
				&.letter {
					margin-right: 0;
				}
			}
		}
		@media all and (max-width: 650px) {
			#name,
			#phone {
				width: 100%;
				margin-right: 0;
			}
			#email {
				width: calc(100% - 135px - 0.5rem);
			}
			#age {
				width: 135px;
			}
			.file-field {
				width: 100%;
			}
			.bottom-field {
				width: 100%;
				select {
					width: 100%;
					margin-right: 0;
				}
			}
		}
		@media all and (max-width: 450px) {
			#email,
			#age {
				width: 100%;
				margin-right: 0;
			}
		}
	}
`;

export default ({ title }) => {
	const [interest, setInterest] = useState('defaultValue');

	const [message, setMessage] = useState(null);
	const [errorMessage, setErrorMessage] = useState(null);

	return (
		<FormStyle>
			<Section bg="white" id="form">
				<Top color="blue">REACH OUT TO ARCADIA</Top>
				<h2>Comments? Questions?</h2>
				<div className="form-container">
					{message && (
						<div className="thanks">
							<h2>Thanks for submitting.</h2>
							<p>{message}</p>
						</div>
					)}
					{!message && (
						<form
							action="/.netlify/functions/form-submit/"
							onSubmit={(event) =>
								mailgunSubmitForm(event, setMessage, setErrorMessage)
							}
							name="lessons"
						>
							<input type="hidden" name="formName" value="lessons" />
							<label className="hide" htmlFor="interest">
								Interest:
							</label>
							<label className="hide" htmlFor="name">
								Name:
							</label>
							<input
								name="name"
								required
								type="text"
								id="name"
								placeholder="Full Name*"
							/>

							<label className="hide" htmlFor="phone">
								Phone:
							</label>
							<input
								type="text"
								id="phone"
								name="phone"
								placeholder="Phone Number"
							/>

							<label className="hide" htmlFor="email">
								Email:
							</label>
							<input
								required
								type="email"
								id="email"
								name="email"
								placeholder="Email*"
							/>

							<label className="hide" htmlFor="age">
								Age:
							</label>
							<input
								required
								type="number"
								id="age"
								name="age"
								placeholder="Student Age*"
							/>

							<div className="bottom-field">
								<label htmlFor="location">Select Location*</label>
								<select
									required
									id="location"
									name="location"
									className={interest === 'unselected' ? 'defaultValue' : ''}
									onClick={(e) => setInterest(e.target.value)}
								>
									<option value="">Location</option>
									<option value="General">General Inquiry</option>
									<option value="Brampton North">Brampton North</option>
									<option value="Brampton South">Brampton South</option>
									<option value="Brampton West">Brampton West</option>
									<option value="Burlington">Burlington</option>
									<option value="Maple">Maple</option>
									<option value="Markham">Markham</option>
									<option value="Newmarket">Newmarket</option>
									<option value="Nobleton">Nobleton</option>
									<option value="Richmond Hill">Richmond Hill</option>
									<option value="Woodbridge">Woodbridge</option>
								</select>
							</div>

							<div className="bottom-field">
								<label htmlFor="interest">
									Which program(s) are you interested in?
								</label>
								<input
									type="text"
									id="interest"
									name="interest"
									placeholder="Program"
								/>
							</div>

							<label className="hide" htmlFor="message">
								Message:
							</label>
							<textarea name="message" id="message" placeholder="Message" />

							<div className="recaptcha-container">
								<ReCAPTCHA
									sitekey={
										process.env.SITE_RECAPTCHA_KEY
											? process.env.SITE_RECAPTCHA_KEY
											: process.env.GATSBY_RECAPTCHA_SITE
									}
								/>
							</div>
							{errorMessage && (
								<ErrorMessage>
									<span dangerouslySetInnerHTML={{ __html: errorMessage }} />
								</ErrorMessage>
							)}
							<Button size="small" bg="blue" type="submit">
								SUBMIT MESSAGE
							</Button>
						</form>
					)}
				</div>
			</Section>
		</FormStyle>
	);
};
